module.exports = __webpack_public_path__ + "static/media/sample-golfer.f1f29567.png";